module.exports = __webpack_public_path__ + "static/img/Stripchat.b600ecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plataformas/Stripchat.png
// module id = xf44
// module chunks = 1